import { applicationChangeProfileConstants, mainActionsConstants } from '../actions/constants';

const initialState = {
    applicationsChangeProfile: [],
    applicationChangeProfileObj: null,
    message: '',
    showAlert: false,
    variantAlert: 'success',
    loading: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_SUCCESS:
            return {
                ...state,
                applicationsChangeProfile: action.payload?.applicationsChangeProfile || [],
                loading: false,
            };

        case applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case applicationChangeProfileConstants.DELETE_APPLICATION_CHANGE_PROFILE_BY_ID_SUCCESS:
            return {
                ...state,
                applicationsChangeProfile: state.applicationsChangeProfile.filter(
                    item => item?._id !== action.payload
                ),
                applicationChangeProfileObj:
                    state.applicationChangeProfileObj?._id === action.payload
                        ? null
                        : state.applicationChangeProfileObj,
                showAlert: true,
                variantAlert: 'success',
                loading: false,
            };

        case applicationChangeProfileConstants.DELETE_MANY_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case applicationChangeProfileConstants.DELETE_MANY_SUCCESS:
        case applicationChangeProfileConstants.DELETE_MANY_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case applicationChangeProfileConstants.GET_BY_ID_REQUEST:
            return {
                ...state,
                applicationChangeProfileObj: null,
                loading: true,
            };

        case applicationChangeProfileConstants.GET_BY_ID_SUCCESS:
            return {
                ...state,
                applicationChangeProfileObj: action.payload?.applicationsChangeProfile || null,
                loading: false,
            };

        case applicationChangeProfileConstants.GET_BY_ID_FAILURE:
            return {
                ...state,
                applicationChangeProfileObj: null,
                loading: false,
            };

        case mainActionsConstants.CANCELLATION_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case mainActionsConstants.CANCELLATION_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                variantAlert: 'success',
                message: action.payload.message,
                applicationChangeProfileObj: action.payload.result,
                showAlert: true,
            };

        case mainActionsConstants.CANCELLATION_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                variantAlert: 'warning',
                showAlert: true,
            };

        case applicationChangeProfileConstants.UPDATE_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case applicationChangeProfileConstants.UPDATE_STATUS_SUCCESS:
            return {
                ...state,
                applicationChangeProfileObj: action.payload.result || state.applicationChangeProfileObj,
                showAlert: true,
                variantAlert: 'success',
                message: action.payload.message || 'Статус заявки обновлён',
                loading: false,
            };

        case applicationChangeProfileConstants.UPDATE_STATUS_FAILURE:
            return {
                ...state,
                showAlert: true,
                variantAlert: 'warning',
                message: action.payload?.message || 'Не удалось обновить статус заявки',
                loading: false,
            };

        case applicationChangeProfileConstants.CLOSE_ALERT:
            return {
                ...state,
                showAlert: false,
            };

        default:
            return state;
    }
};

export const setCloseAlertApplicationChangeProfile = payload => ({
    type: applicationChangeProfileConstants.CLOSE_ALERT,
    payload,
});

export const setApplicationChangeProfile = applicationsChangeProfile => ({
    type: applicationChangeProfileConstants.GET_ALL_APPLICATION_CHANGE_PROFILE_SUCCESS,
    payload: applicationsChangeProfile,
});
